import React from 'react';
import { useKeycloak } from '@react-keycloak/web';
import './style.css';
import { jwtDecode } from 'jwt-decode';
import {
  setUserSession,
  setrefreshtoken,
  setaccesstoken,
  getAcl,
  getToken,
  removeUserSession,
  fetchLog,
} from '../../utils/common';

const LoginButton = () => {
  const { keycloak } = useKeycloak();
  const token = getToken();
  let navconficCustom = [];
  const navConfig = [
    {
      title: 'dashboard',
      path: '/dashboard/app',
      namaroute: 'dashboard',
    },
    {
      title: 'users',
      path: '/dashboard/user',
      namaroute: 'user',
    },
    {
      title: 'actions',
      path: '/dashboard/action',
      namaroute: 'action',
    },
    {
      title: 'alerts',
      path: '/dashboard/alert',
      namaroute: 'alert',
    },
    {
      title: 'reports',
      path: '/dashboard/report',
      namaroute: 'report',
    },
    {
      title: 'bulletins',
      path: '/dashboard/blog',
      namaroute: 'bulletin',
    },
    {
      title: 'information',
      path: '/dashboard/information',
      namaroute: 'information',
    },
    {
      title: 'Dataset Map',
      path: '/dashboard/dataset',
      namaroute: 'data_set',
    },
    {
      title: 'About',
      path: '/dashboard/about',
      namaroute: 'about',
    },
    {
      title: 'Activity Log',
      path: '/dashboard/activitylogs',
      namaroute: 'activity',
    },
    {
      title: 'logout',
      path: '/login',
      namaroute: 'logout',
    },
  ];

  return (
    <button
      className="button-93"
      onClick={async () => {
        if (!keycloak.authenticated) {
          keycloak.login({ redirectUri: window.location.origin });
          return;
        }

        // If authenticated, proceed with your logic
        const token = keycloak.token;
        if (!token) {
          console.error('No token available');
          return;
        }

        try {
          const decoded = jwtDecode(token);
          const roles = decoded.resource_access.smartshield?.roles?.[0];
          if (!roles) {
            alert('Please contact your administrator to get access to the system');
            fetch(
              `${keycloak.authServerUrl}/realms/${keycloak.realm}/protocol/openid-connect/logout?id_token_hint=${keycloak.idToken}&post_logout_redirect_uri=${window.location.origin}`
            ).then(async () => {
              window.location.href = `${window.location.origin}`;
            });
            return;
          }
          const fullname = decoded.family_name;
          const email = decoded.email;

          // Save user session data
          setUserSession(keycloak.token, keycloak.refreshToken, email, roles, fullname);

          // Initial attempt to get ACL data
          let acl = getAcl();
          let maxRetries = 10;
          let attempts = 0;

          // Loop until acl is filled or max retries is reached
          while ((!acl || acl.length === 0) && attempts < maxRetries) {
            attempts += 1;
            await new Promise((resolve) => setTimeout(resolve, 1000)); // 1-second delay
            acl = getAcl(); // Retry getting ACL data
          }

          // Handle failure to retrieve ACL data after retries
          if (!acl || acl.length === 0) {
            console.error('Failed to retrieve ACL data after multiple attempts');
            return;
          }

          // Parse the ACL JSON
          const aclJson = JSON.parse(acl);

          // Customize the navigation config based on ACL
          navConfig.forEach((c) => {
            const menu = aclJson?.find((e) => c.namaroute === e.nama_menu && e.read === true);
            if (menu || c.namaroute === 'logout') {
              navconficCustom.push(c);
            }
          });

          // Redirect the user after login
          keycloak.login({ redirectUri: window.location.origin + navconficCustom[0]?.path });
        } catch (error) {
          console.error('Error during token decoding or login process:', error);
        }
      }}
    >
      {token ? 'Dashboard' : 'Login'}
    </button>
  );
};

const LogoutButton = () => {
  const { keycloak } = useKeycloak();
  let setClick = false;
  return (
    <button
      class="button-94"
      disabled={setClick}
      onClick={() => {
        setClick = true;
        setTimeout(() => {
          fetchLog(window.REACT_APP_API_PURE + 'user/logout');
          sessionStorage.clear();
          keycloak.login();
          removeUserSession();
        }, 2000);
      }}
    >
      Logout
    </button>
  );
};

export { LoginButton, LogoutButton };
